module.exports = __webpack_public_path__ + "static/smart-sm-detail-f69b216cd7ac2deaf2175b685946f73e.jpg";